export class InvalidFieldError extends Error {
    constructor(param) {
        super(param || 'Invalid field');
    }
}
